import React from "react";
import "../styles/_almarehotel.scss";
interface Props {}

const AlMareHotel: React.FC<Props> = (props) => {
  return (
    <div className="AlMareHotel container padding100" id="theHotel">
      <div className="row align-items-center">
        <div className="col-lg-6 col-12">
          <h6 className="text-start">AL-MARE</h6>
          <h1 className="text-start">THE HOTEL</h1>
          <p>
            Al-Mare Hotel*** superior is located on the first of the three
            Chalkidiki fingers, one of the most popular tourist regions in the
            Eastern Mediterranean.
            <br /> <br />
            Al-Mare is an attractive tourist destination. The hotel is nested in
            an ideal location, by the sea shore, surrounded by the peace and
            quiet of the pine forest. Thessaloniki and the Thessaloniki airport
            are 85 km away, while the small picturesque town of Polichrono is
            about 2 km away.
            <br /> <br />
            Al-Mare offers excellent vacation possibilities, away from the city
            jam, opportunities for sightseeing in the nearby archeological
            sites, spas and untouched nature. However, if you are more
            interested in active vacation, the night club and taverns
            (traditional Greek restaurants) zone is also in the vicinity of the
            hotel.
            <br /> <br />
            The Al-Mare team treats each hotel guest as being a guest in their
            own home!
            <br /> <br />
            <span> Al-Mare Team</span>
          </p>
        </div>
        <div className="col-lg-6 col-12">
          <div className="row">
            <div className="col-lg-6 col-12">
              <img src="hotel1.jpg" alt="" className="w-100 bottomImg" />
            </div>
            <div className="col-lg-6 col-12">
              <img src="hotel2.jpg" alt="" className="w-100 topImg" />
            </div>
            <div className="col-lg-6 col-12">
              <img src="dream.jpg" alt="" className="w-100 upImg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlMareHotel;
